export const foodShowcaseTranslations = {
  nl: {
    title: "Een Voorproefje van Onze",
    specialties: "Specialiteiten",
    subtitle: "Ontdek enkele van onze populairste gerechten, met liefde bereid met de meest verse ingrediënten en authentieke recepten.",
    idlyAlt: "Idly schotel, een traditioneel Zuid-Indiaas en Sri Lankaans ontbijtgerecht.",
    vadaAlt: "Vada, een hartige gefrituurde snack uit India en Sri Lanka.",
    kipKerrieAlt: "Surinaams broodje met kip kerrie.",
    rotiPlaatAlt: "Roti plaat, een Surinaams gerecht met roti, kip masala, aardappelen en kousenband.",
  },
  en: {
    title: "A Taste of Our",
    specialties: "Specialties",
    subtitle: "Discover some of our most popular dishes, prepared with love using the freshest ingredients and authentic recipes.",
    idlyAlt: "Idly dish, a traditional South Indian and Sri Lankan breakfast item.",
    vadaAlt: "Vada, a savory fried snack from India and Sri Lanka.",
    kipKerrieAlt: "Surinamese sandwich with chicken curry.",
    rotiPlaatAlt: "Roti plate, a Surinamese dish with roti, chicken masala, potatoes, and green beans.",
  },
};